import type { RouteObject } from "react-router-dom";
import { addSlashes, withCompanyPrefix } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import {
  CompanyTasks,
  CompanyTaskBoard,
  CompanyTaskDetail,
} from "@/utils/lazyLoadComponents";

export enum COMPANY_TASKS_PATH_SEGMENTS {
  ROOT = "project-management",
  BOARD = "board/:projectId",
  // Relative to BOARD — the task detail is nested under its board so the
  // breadcrumb trail reads Project Management › Board › Task.
  DETAILS = "task/:taskId",
}

export const companyTasksRoutes: RouteObject = {
  path: COMPANY_TASKS_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Project Management" },
  HydrateFallback: Spinner,
  children: [
    { index: true, Component: CompanyTasks },
    {
      path: COMPANY_TASKS_PATH_SEGMENTS.BOARD,
      handle: { breadcrumb: "Board" },
      children: [
        { index: true, Component: CompanyTaskBoard },
        {
          path: COMPANY_TASKS_PATH_SEGMENTS.DETAILS,
          handle: { breadcrumb: "Task" },
          Component: CompanyTaskDetail,
        },
      ],
    },
  ],
};

export const COMPANY_TASKS_PATHS = Object.freeze({
  ROOT: withCompanyPrefix(addSlashes(COMPANY_TASKS_PATH_SEGMENTS.ROOT)),
  BOARD: (projectId: string | number) =>
    withCompanyPrefix(
      addSlashes(COMPANY_TASKS_PATH_SEGMENTS.ROOT, "board", String(projectId)),
    ),
  DETAIL: (projectId: string | number, taskId: string | number) =>
    withCompanyPrefix(
      addSlashes(
        COMPANY_TASKS_PATH_SEGMENTS.ROOT,
        "board",
        String(projectId),
        "task",
        String(taskId),
      ),
    ),
});
